import {inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {IS_SHOWCASE} from '../tokens/is-showcase.token';
import {SEO_CONFIG} from './seo-config.token';
import {resolveTitle} from './seo-meta.helpers';
import {routeTitleLabel} from './page-title.util';

/**
 * Заголовок вкладки страницы кабинета: подпись через шаблон заголовка из SEO-настроек
 * (`metaDefaults.titleTemplate`, `%s` — подпись), как у `SeoMetaService.apply` — формат один на всё
 * приложение. Вид прототипа «Каталог техники · XCMG» включается шаблоном `%s · XCMG` в админке.
 */
@Injectable({providedIn: 'root'})
export class PageTitleService {
  private readonly title = inject(Title);
  private readonly seoConfig = inject(SEO_CONFIG, {optional: true});

  set(label: string | null | undefined): void {
    if (label) {
      this.title.setTitle(resolveTitle(label, this.seoConfig?.metaDefaults?.titleTemplate ?? null, undefined));
    }
  }
}

/**
 * Заголовок вкладки по маршруту: Angular-`title` или подпись крошки самого глубокого маршрута.
 * Без неё каждая страница портала оставляла бы заголовок предыдущей. Экраны, которые ставят
 * заголовок сами (`seo.apply`, `storeService.setTitle`, карточки товара после загрузки), делают это
 * позже — в `ngOnInit`/по данным — и перекрывают этот. Витрину не трогаем: там заголовки — SEO-сервис.
 */
@Injectable()
export class PortalTitleStrategy extends TitleStrategy {
  private readonly pageTitle = inject(PageTitleService);
  private readonly isShowcase = inject(IS_SHOWCASE, {optional: true});

  override updateTitle(snapshot: RouterStateSnapshot): void {
    if (!this.isShowcase) {
      this.pageTitle.set(routeTitleLabel(snapshot.root));
    }
  }
}
